import { Controller } from "@hotwired/stimulus"

// Submits the contact form with fetch() and shows the server's JSON answer in
// place, so the visitor stays on the page. Without JavaScript the form posts
// normally and the controller redirects with a flash message.
export default class extends Controller {
  static targets = ["feedback", "submit"]
  static values = { sendingLabel: String, networkError: String }

  async submit(event) {
    event.preventDefault()
    this.#setBusy(true)

    try {
      const response = await fetch(this.element.action, {
        method: "POST",
        body: new FormData(this.element),
        headers: { Accept: "application/json" },
        credentials: "same-origin"
      })
      const data = await response.json()

      this.#showFeedback(data.success ? "success" : "danger", data.message, data.errors)
      if (data.success) this.element.reset()
    } catch {
      this.#showFeedback("danger", this.networkErrorValue)
    } finally {
      this.#setBusy(false)
    }
  }

  #setBusy(busy) {
    this.submitTarget.disabled = busy
    if (busy) {
      this.submitLabel ??= this.submitTarget.textContent
      this.submitTarget.textContent = this.sendingLabelValue
    } else {
      this.submitTarget.textContent = this.submitLabel
    }
  }

  #showFeedback(kind, message, errors = []) {
    const alert = document.createElement("div")
    alert.className = `alert alert-${kind} mb-0`
    alert.textContent = message

    if (errors.length > 0) {
      const list = document.createElement("ul")
      list.className = "mb-0 mt-2 small"
      errors.forEach((error) => {
        const item = document.createElement("li")
        item.textContent = error
        list.append(item)
      })
      alert.append(list)
    }

    this.feedbackTarget.replaceChildren(alert)
  }
}
